import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components';
import { media } from 'theme';
import clsx from 'clsx';
import colors from '../themes/colors';
import Text from '../text';

export const StyledTextArea = styled(TextareaAutosize)`
  font-family: inherit;
  font-size: ${props => props.fontTheme.fontSize};
  font-weight: ${props => props.fontTheme.fontWeight};
  line-height: ${props => props.fontTheme.lineHeight};
  border: none;
  width: 100%;
  min-height: ${props => props.minheight};
  outline: ${props => !props.outline && 'none'};
  resize: ${props => props.resize};

  :placeholder {
    color: ${colors.neutral5};
    font-size: ${props => props.fontTheme.fontSize};
    font-weight: ${props => props.fontTheme.fontWeight};
  }

  ${media.largeAndDown`
    font-size: 16px;
  `}
`;

const TextAreaTheme = {
  default: {
    fontSize: 'inherit',
    fontWeight: 'normal',
    lineHeight: 'normal',
  },
  titlelg: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px',
  },
};

const TextArea = props => {
  const {
    prefix = null,
    postfix = null,
    isError = false,
    minHeight = '60px',
    wordLeft = undefined,
    wordLeftDesc = 'words left',
    theme = 'default',
    resize = 'initial',
    ...otherProps
  } = props;

  const textIntent = isError ? 'error' : 'secondary';
  const textAreaTheme = TextAreaTheme[theme];

  return (
    <div
      className={clsx(
        'bg-white border border-solid p-2 rounded-lg',
        isError ? 'border-red-500' : 'border-neutral-400',
      )}
    >
      <div className="flex flex-col items-end w-full gap-4">
        <div className="flex gap-2 w-full">
          {prefix}
          <StyledTextArea
            fontTheme={textAreaTheme}
            resize={resize}
            minheight={minHeight}
            {...otherProps}
          />
          {postfix}
        </div>
        {typeof wordLeft === 'number' && (
          <div style={{ textAlign: 'end' }}>
            <Text intent={textIntent}>
              {wordLeft} {wordLeftDesc}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default TextArea;
